<template>
  <div class="plan">
    <!-- 草肉菜肖 -->
    <caoroucaixiao :data="data.caoroucaixiao" v-if="data?.caoroucaixiao" />
    <van-image
      v-if="listPicture[0]"
      :src="listPicture[0]?.pictureUrl"
      width="100%"
      height="auto"
      fit="cover"
      lazy-load
      class="image"
    />
    <!-- 精选30码 -->
    <jingxuansanshima
      :data="data.jingxuansanshima"
      v-if="data?.jingxuansanshima"
    />
    <van-image
      v-if="listPicture[1]"
      :src="listPicture[1]?.pictureUrl"
      width="100%"
      height="auto"
      fit="cover"
      lazy-load
      class="image"
    />
    <!-- 三头中特 -->
    <santouzhongte :data="data.santouzhongte" v-if="data?.santouzhongte" />
    <imgsVue type="1" :list="imgdata.slice(0, 2)" /><imgsVue
      :list="imgdata.slice(0, 2)"
    />
    <van-image
      v-if="listPicture[4]"
      :src="listPicture[4]?.pictureUrl"
      width="100%"
      height="auto"
      fit="cover"
      lazy-load
      class="image"
    />
    <imgsVue type="1" :list="imgdata.slice(0, 2)" />
    <imgsVue type="1" :list="imgdata.slice(0, 2)" />
    <!-- 三行主十码 -->
    <sanxingzhushima
      :data="data.sanxingzhushima"
      v-if="data?.sanxingzhushima"
    />
    <!-- 绝杀三肖 -->
    <jueshasanxiao :data="data.jueshasanxiao" v-if="data?.jueshasanxiao" />
    <van-image
      v-if="listPicture[3]"
      :src="listPicture[3]?.pictureUrl"
      width="100%"
      height="auto"
      fit="cover"
      lazy-load
      class="image"
    />
    <!-- 家野三肖 -->
    <jiayesanxiao :data="data.jiayesanxiao" v-if="data?.jiayesanxiao" />
    <!-- 天地必中 -->
    <tiandibizhong :data="data.tiandibizhong" v-if="data?.tiandibizhong" />
    <van-image
      v-if="listPicture[4]"
      :src="listPicture[4]?.pictureUrl"
      width="100%"
      height="auto"
      fit="cover"
      lazy-load
      class="image"
    />
    <!-- 单双+四肖 -->
    <baoteqixiao :data="data.baoteqixiao" v-if="data?.baoteqixiao" />
    <!-- 单双+四肖 -->
    <danshuangsixiao
      :data="data.danshuangsixiao"
      v-if="data?.danshuangsixiao"
    />
    <!-- 单双+二肖 -->
    <danshuangerxiao
      :data="data.danshuangerxiao"
      v-if="data?.danshuangerxiao"
    />
    <!-- 琴棋书画 -->
    <qinqishuhuaxiao
      :data="data.qinqishuhuaxiao"
      v-if="data?.qinqishuhuaxiao"
    />
    <!-- 广告轮播 -->
    <van-image
      v-if="listPicture[0]"
      :src="listPicture[0]?.pictureUrl"
      width="100%"
      height="auto"
      fit="cover"
      lazy-load
      class="image"
    />
    <imgsVue type="1" :list="imgdata.slice(0, 2)" />
    <van-image
      v-if="listPicture[1]"
      :src="listPicture[1]?.pictureUrl"
      width="100%"
      height="auto"
      fit="cover"
      lazy-load
      class="image"
    />
    <!-- 平特四码 -->
    <pingtesima :data="data.pingtesima" v-if="data?.pingtesima" />
    <imgsVue type="1" :list="imgdata.slice(0, 2)" />
    <!-- 平特六码 -->
    <pingteliuma :data="data.pingteliuma" v-if="data?.pingteliuma" />
    <van-image
      v-if="listPicture[2]"
      :src="listPicture[2]?.pictureUrl"
      width="100%"
      height="auto"
      fit="cover"
      lazy-load
      class="image"
    />
    <!-- 站点推荐 -->
    <zhandianVue
      :list="data2.slice(9, 21)"
      type="1"
      title="全网彩民公认的好站点"
    />
    <!-- 平特五码 -->
    <pingtewuma :data="data.pingtewuma" v-if="data?.pingtewuma" />
    <!-- 平特四不中 -->
    <pingtesibuzhong
      :data="data.pingtesibuzhong"
      v-if="data?.pingtesibuzhong"
    />
    <!-- 平特五不中 -->
    <pingtewubuzhong
      :data="data.pingtewubuzhong"
      v-if="data?.pingtewubuzhong"
    />
    <!-- 平特六不中 -->
    <pingteliubuzhong
      :data="data.pingteliubuzhong"
      v-if="data?.pingteliubuzhong"
    />
    <liuweibizhong :data="data.liuweibizhong" v-if="data?.liuweibizhong" />
  </div>
</template>

<script setup>
import { myHttp } from "@/request/index.js";
import { ref } from "vue";
import liuxiao from "./liuxiao.vue";
import niubishuangbo from "./niubishuangbo.vue";
import danshuang from "./danshuang.vue";
import tou from "./tou.vue";
import wei from "./wei.vue";
import yixiao from "./yixiao.vue";
import code24 from "./code24.vue";
import sanxiao from "./sanxiao.vue";
import daxiao from "./daxiao.vue";
import wuXingZhongTe from "./wuXingZhongTe.vue";
import pingteyiwei111 from "./pingteyiwei111.vue";
import shimafangwuma from "./shimafangwuma.vue";
import fengyuleidian from "./fengyuleidian.vue";
import shibamabizhong from "./shibamabizhong.vue";
import jiaqinyeshou from "./jiaqinyeshou.vue";
import chengyupingte from "./chengyupingte.vue";
import jihuapingteyixiao from "./jihuapingteyixiao.vue";
import liuweibizhong from "./liuweibizhong.vue";
import pingteliubuzhong from "./pingteliubuzhong.vue";
import pingtewubuzhong from "./pingtewubuzhong.vue";
import pingtesibuzhong from "./pingtesibuzhong.vue";
import pingteliuma from "./pingteliuma.vue";
import pingtewuma from "./pingtewuma.vue";
import pingtesima from "./pingtesima.vue";
import danshuangerxiao from "./danshuangerxiao.vue";
import qinqishuhuaxiao from "./qinqishuhuaxiao.vue";
import danshuangsixiao from "./danshuangsixiao.vue";
import baoteqixiao from "./baoteqixiao.vue";
import tiandibizhong from "./tiandibizhong.vue";
import jiayesanxiao from "./jiayesanxiao.vue";
import jueshasanxiao from "./jueshasanxiao.vue";
import sanxingzhushima from "./sanxingzhushima.vue";
import santouzhongte from "./santouzhongte.vue";
import jingxuansanshima from "./jingxuansanshima.vue";
import caoroucaixiao from "./caoroucaixiao.vue";
//
import { imgdata, data2 } from "../../utils/data";
import imgsVue from "../../components/imgs.vue";
import zhandianVue from "../../components/zhandian.vue";
import { drawHttp } from "../../request/index";

const data = ref(null);

function loadData() {
  myHttp.get("/api/information/queryAll_6").then((res) => {
    if (res.success) {
      data.value = res.data;
      console.log(res.data, "plan");
    }
  });
}

loadData();

const listPicture = ref([]);
async function getlistPicture() {
  const res = await drawHttp({
    method: "get",
    url: `/gallerynew/h5/index/listPicture?pageNum=1&Lotterytype=2`,
  });
  const newList = res.list || [];
  listPicture.value.push(...newList);
}
getlistPicture();
</script>

<style lang="scss" scoped>
::v-deep .plan_item {
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  .plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  .plan_item_title {
    font-weight: bold;
    text-align: center;
    padding: 3px 0;
    background: #44d066 !important;
    color: #fff !important;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .name {
    color: #0000ff !important;
  }
  ul {
    background-color: #eee;
    margin-top: -12px;
    border-radius: 12px 12px 0 0;
    overflow: hidden;
    li {
      text-align: center;
      padding: 0px 0px;
      font-weight: bold;
      display: block !important;
      line-height: 35px;
      justify-content: center;
      .naoji {
        background-color: #ccffcc;
        font-weight: 400;
        color: red;
      }
      .value {
        color: red;
        font-size: 20px;
        background-color: #0000ff54;
        padding: 0 3px;
        .win {
          background-color: #ffff00;
        }
      }
      &:not(:last-child) {
        border-bottom: 2px solid #d2d2d2;
      }
      .yuce {
        display: flex;
        flex: 1;
        justify-content: center;
        // border-right: 2px solid #ccc;
      }
      .qi {
        color: blue;
        width: 100%;
        display: block;
        font-weight: 400;
        background: #ffccff;
        // border-right: 2px solid #ccc;
      }
      .winText {
        width: 25%;
      }
      .suck {
        text-decoration-line: none;
      }
    }
  }
}
.plan {
  .title {
    text-align: center;
    background-color: #4292ef;
    font-size: 25px;
    font-weight: bold;
    padding: 6px 0;
  }
}
</style>